import { compose } from 'ramda';
import { branch, defaultProps, renderNothing, withProps } from 'recompose';
import { usePortletTranslations } from 'js/components/system/Portlet';
import withCountDown from '../../withCountDown';
import { COUNT_DOWN_FORMAT, countDownModeTypes, statuses as raceStatuses } from '../../constants';
import { parseTimeTillEnd } from './helpers';

export const withModeType = withProps(
    ({ status, statuses }) => ({
        modeType: status === statuses.NOT_STARTED
            ? countDownModeTypes.START
            : countDownModeTypes.END
    })
);

export const withActiveCountDown = compose(
    withModeType,
    withCountDown,
    withProps(
        ({ timeTillEnd, modeType, regPrefix = '' }) => {
            const t = usePortletTranslations();
            const format = timeTillEnd.days === 0
                ? timeTillEnd.hours === 0
                    ? COUNT_DOWN_FORMAT.mmSS
                    : COUNT_DOWN_FORMAT.hhMM
                : COUNT_DOWN_FORMAT.ddHHmm;

            return {
                label: t(`${regPrefix}countDown.mode.${modeType}`),
                value: t(`${regPrefix}countDown.timeTillEnd.${format}`, parseTimeTillEnd(timeTillEnd, format))
            };
        }
    )
);

export default compose(
    branch(
        ({ endTime, startTime }) => !endTime && !startTime,
        renderNothing
    ),
    defaultProps({
        statuses: raceStatuses
    }),
    withProps(
        ({ status, statuses }) => ({ isCompleted: status === statuses.COMPLETED || status === statuses.PENDING_REVIEW })
    ),
    branch(
        ({ isCompleted }) => !isCompleted,
        withActiveCountDown
    )
);
